//axios api
import api from "@/lib/Api";

export const getAllUser = async () => {
  try {
    const queryRoute = `/user/getAllUser/`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getUserDetail = async (id) => {
  try {
    const queryRoute = `/user/getUserDetail/${id}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createOrUpdateUser = async (data, id) => {
  try {
    const queryRoute = `/user/createOrUpdateUser/${id}`;

    const reqBody = {
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getUserProductInvoiceTotal = async (id, date) => {
  try {
    const queryRoute = `/user/getUserProductInvoiceTotal`;

    const reqBody = {
      id: id,
      date: date ? date : null,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const generateQRcode = async (staff_id) => {
  try {
    const queryRoute = `/user/generateQRcode`;
    const reqBody = {
      staff_id,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getAllPromoter = async (includes_deleted = false) => {
  try {
    const queryRoute = `/user/promoters?includes_deleted=${
      includes_deleted ? 1 : 0
    }`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getAllUserByWorkId = async (workLocationId) => {
  try {
    const queryRoute = `/user/getAllUserByWorkId`;

    const reqBody = {
      workLocationId: workLocationId,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
